import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useRef, useEffect, useState } from 'react';
export var useDelayedState = function useDelayedState(initialState, delay) {
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var timeoutRef = useRef(null);
  useEffect(function () {
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  var handleDelayedStateChange = useCallback(function (newState) {
    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (immediate || delay === 0) {
      setState(newState);
    } else {
      timeoutRef.current = setTimeout(function () {
        setState(newState);
      }, delay);
    }
  }, [delay]);
  return [state, handleDelayedStateChange];
};